import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-params-modal',
  templateUrl: './params-modal.component.html',
  styleUrls: ['./params-modal.component.scss']
})
export class ParamsModalComponent implements OnInit {
  @Input() data: any;
  @Input() mapParams: any;
  sliderOption = {floor: 0, ceil: 20, showSelectionBar: true};

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit(): void {
  }

  setValue(field: string, value: any): void {
    this.mapParams[field] = (typeof value === 'string') ? value : value.value;
  }

  save(): void {
    this.activeModal.close({...this.mapParams});
  }
}
